export default "__VITE_ASSET__N6YTC$4$__"